'use client';
import { css, cx } from '@mildang/styled-system/css';
import type { ColorToken } from '@mildang/styled-system/types';
import type { CustomSpinnerProps } from './type';
import { CircularProgress } from './CircularProgress';
import { migrateSize } from '../../lib/migrateSize';

// 컨테이너: 겹쳐진 원형 프로그레스 두 개를 포개기 위한 래퍼
const containerStyle = css({
  position: 'relative',
  display: 'inline-flex',
});

// 트랙(바탕 원) 스타일: 상단에 인디케이터가 포개지므로 절대 위치
const trackOverlayStyle = css({
  position: 'absolute!',
  left: 0,
});

export const Spinner = (props: CustomSpinnerProps) => {
  const { className, color = 'green', size = 'lg', ...restProps } = props;
  const _size = (typeof size === 'number' ? size : migrateSize(size)) as typeof size;

  return (
    <div className={cx(containerStyle, className)}>
      {/*
        `{...restProps}` 를 **앞에** 둔다. 두 원의 역할을 정하는 `variant`/`value`/`color` 가
        스프레드 뒤에 와야 밖에서 온 값에 덮이지 않는다. 지금은 `CustomSpinnerProps` 가
        `variant`/`value`/`children` 을 잘라내서 타입으로도 막지만, 나중에 상속 대상이 넓어질 때
        순서가 남아 있으면 같은 사고가 반복되지 않는다.
      */}
      {/* 트랙(바탕) */}
      <CircularProgress
        {...restProps}
        variant="determinate"
        value={100}
        className={trackOverlayStyle}
        color={`spinner.track.${color}` as ColorToken}
        size={_size}
      />
      {/* 인디케이터(회전) */}
      <CircularProgress
        {...restProps}
        variant="indeterminate"
        color={`spinner.indicator.${color}` as ColorToken}
        size={_size}
      />
    </div>
  );
};
